import React from 'react';
import { Box } from '@chakra-ui/react';
import { FaMapMarkerAlt } from 'react-icons/fa';

interface LocalCreatorsBrandMarkProps {
  /** Tile edge length in px (40 profile row, 60 welcome modal). */
  size?: number;
}

/** Orange gradient tile with map pin — Local Creators brand mark. */
const LocalCreatorsBrandMark: React.FC<LocalCreatorsBrandMarkProps> = ({ size = 40 }) => {
  const pinSize = Math.round((size / 60) * 28);
  const borderRadius = Math.round((size / 60) * 18);

  return (
    <Box
      w={`${size}px`}
      h={`${size}px`}
      borderRadius={`${borderRadius}px`}
      border="1px solid"
      borderColor="rgba(245, 74, 0, 0.5)"
      bgGradient="linear(to-b, #ff8904, #f54900)"
      boxShadow="0 2px 4px 0 rgba(194, 65, 12, 0.25), 0 8px 20px -4px rgba(194, 65, 12, 0.35), inset 0 1px 0 1px rgba(255, 255, 255, 0.5)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexShrink={0}
      aria-hidden
    >
      <Box
        as="span"
        color="white"
        lineHeight={0}
        filter="drop-shadow(0 1px 0.5px rgba(0,0,0,0.15))"
      >
        <FaMapMarkerAlt size={pinSize} />
      </Box>
    </Box>
  );
};

export default LocalCreatorsBrandMark;
